import { render, staticRenderFns } from "./IncidentConfirmTab.vue?vue&type=template&id=10b64e88"
import script from "./IncidentConfirmTab.js?vue&type=script&lang=js&external"
export * from "./IncidentConfirmTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports